// src/pages/SriLanka.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { motion, AnimatePresence } from 'framer-motion';

// === HERO & INTRO IMAGES ===
import sriLankaHeroBg from '../assets/Sonic/33.jpeg';
import introImage from '../assets/Sonic/sri.png';

// === PLACE IMAGES (unchanged — keep your current imports) ===
import place1 from '../assets/Sri Lanka/800px-Sigiriya_(141688197).jpeg';
import place17 from '../assets/Sri Lanka/Sigiriya-Uncovered-Delving-into-the-History-Art-and-Legends-800x609-1.jpg';
import place18 from '../assets/Sri Lanka/01.jpg';
import place19 from '../assets/Sri Lanka/Sigriya_rock_from_directly_above_1600x.webp';

import place2 from '../assets/Sri Lanka/Kandy-toothrelictemple-dawn.jpg';
import place20 from '../assets/Sri Lanka/temple-sacred-tooth-relic-kandy-sri-lanka.jpg';
import place21 from '../assets/Sri Lanka/Temple-Sacred-Tooth-Relic-kandy-sri-lanka (1).jpg';
import place22 from '../assets/Sri Lanka/Kandy-and-The-Temple.jpg';

import place3 from '../assets/Sri Lanka/Nine Arch Bridge Sri Lanka.jpg';
import place23 from '../assets/Sri Lanka/little-adams-peak-ella-1440x960.jpg';
import place24 from '../assets/Sri Lanka/POST_PORTRAIT_0002_IMG_9077.webp';
import place25 from '../assets/Sri Lanka/52773560Ravana_Falls.jpg';

import place4 from '../assets/Sri Lanka/Yala-National-Park-1.jpg';
import place26 from '../assets/Sri Lanka/hq720.jpg';
import place27 from '../assets/Sri Lanka/image_872e72884c.jpg';
import place28 from '../assets/Sri Lanka/yala-safari-srilanka-economy-tours.jpg.webp';

import place5 from '../assets/Sri Lanka/Galle-Fort.webp';
import place29 from '../assets/Sri Lanka/galle_147f8ef7-7d19-4c30-9069-eb59128e1c2c.webp';
import place30 from '../assets/Sri Lanka/Galle-Fort-Walking-Tour-555x655-1.jpg';
import place31 from '../assets/Sri Lanka/shutterstock-409990654_main_1490260387805.jpeg';

import place6 from '../assets/Sri Lanka/nuwara-eliya-in-sri-lanka.jpg';
import place32 from '../assets/Sri Lanka/historical-background-in-nuwara-eliya.jpg';
import place33 from '../assets/Sri Lanka/grand-hotel-nuwara-eliya.jpg';
import place34 from '../assets/Sri Lanka/nuwara-eliya-gregory.jpg';

import place7 from '../assets/Sri Lanka/Climb-Adams-Peak-Sri-Pada.webp';
import place35 from '../assets/Sri Lanka/Adams-Peak-Sri-Lanka.webp';
import place36 from '../assets/Sri Lanka/mini-adams-peak-1-7.jpg';
import place37 from '../assets/Sri Lanka/adams-peak-season.jpg';

import place8 from '../assets/Sri Lanka/800x750-94.jpg';
import place38 from '../assets/Sri Lanka/Michael-at-Worlds-End-View-Horton-Plains-National-Park.jpg';
import place39 from '../assets/Sri Lanka/horton-plains-national.jpg';
import place40 from '../assets/Sri Lanka/Horton-Plains-Nature-Reserve-800x600-1.webp';

import place9 from '../assets/Sri Lanka/Bentota-Sri-Lanka-Everything-You-Need-To-Know.jpg';
import place41 from '../assets/Sri Lanka/Ventura-Beach-Sri-Lanka-Bentota-Beach-2023-2024.jpg';
import place42 from '../assets/Sri Lanka/bentota.jpg';
import place43 from '../assets/Sri Lanka/01 (1).jpg';

import place10 from '../assets/Sri Lanka/images.jpeg';
import place44 from '../assets/Sri Lanka/1332748-jaffna-library.jpg';
import place45 from '../assets/Sri Lanka/Jaffna-Fort-Jaffna-Sri-Lanka.jpg.webp';
import place46 from '../assets/Sri Lanka/Nainatheevu-in-Jaffna-768x1024.jpeg';

import place11 from '../assets/Sri Lanka/800x750-1.jpg';
import place47 from '../assets/Sri Lanka/shutterstock-480723793_main_1481633955837.jpeg';
import place48 from '../assets/Sri Lanka/Avukana-Buddha-Statue-Anuradhapua-Ancinet-City.webp';
import place49 from '../assets/Sri Lanka/Anuradhapura-788x537.webp';

import place12 from '../assets/Sri Lanka/Polonnaruwa-Lankathilaka-Feature-Image.jpg';
import place50 from '../assets/Sri Lanka/UNESCO-World-Heritage-Site-Brahmanic-Monuments-Polonnaruwa-Sri-Lanka-1.jpg';
import place51 from '../assets/Sri Lanka/ThePolonnaruwaVatadage-857341721661428.jpg';
import place52 from '../assets/Sri Lanka/polonnaruwa-640x360.jpg';

import place13 from '../assets/Sri Lanka/Unawatuna-Beach-1.jpg';
import place53 from '../assets/Sri Lanka/Unawatuna-Beach-Sri-Lanka.webp';
import place54 from '../assets/Sri Lanka/20190926_080608-1024x768.webp';
import place55 from '../assets/Sri Lanka/jungle-beach-unawatuna-00-1024x768.webp';

import place14 from '../assets/Sri Lanka/37.jpg';
import place56 from '../assets/Sri Lanka/Colombo-city.jpg';
import place57 from '../assets/Sri Lanka/colombo-main-header.jpg';
import place58 from '../assets/Sri Lanka/ee.jpg';

import place15 from '../assets/Sri Lanka/udawalawe-national-park.jpg';
import place59 from '../assets/Sri Lanka/Udawalawe-National-Park-2.jpeg';
import place60 from '../assets/Sri Lanka/12f5bb1d6b11d9f5a5a9b1f64c59bd41-uda-walawe-national-park.jpg';
import place61 from '../assets/Sri Lanka/156-1024x683.jpg';

import place16 from '../assets/Sri Lanka/01 (2).jpg';
import place62 from '../assets/Sri Lanka/800x750-9.jpg';
import place63 from '../assets/Sri Lanka/dambulla-cave-temple-architecture-1024x585.jpg';
import place64 from '../assets/Sri Lanka/555x465px-Dambulla_cave_temple_37.webp';

// === FAMOUS THINGS IMAGES ===
import ceylonTea from '../assets/Sri Lanka/30917a4b2dee144385c49297465d68a3_XL-768x340.jpg';
import spices from '../assets/Sri Lanka/Spices_1200px_23_11_16-1000x600.jpg';
import gems from '../assets/Sri Lanka/Untitled-61.jpg';
import ayurveda from '../assets/Sri Lanka/Ayurveda-Background-gallery-pop-up-(1)-min.jpg';
import handicrafts from '../assets/Sri Lanka/Local-handicraft-workshops-and-shopping-in-Galle.jpg';
import elephants from '../assets/Sri Lanka/Asian-elephant-Elephas-Maximus.webp';
import food from '../assets/Sri Lanka/1689750105634.jpeg';
import festivals from '../assets/Sri Lanka/Three-tuskers-clad-in-illuminated-red-costumes-standing-in-front-of-the-illuminated-white-building-complex-1.jpg';
import coconut from '../assets/Sri Lanka/processed-coconut-products.webp';
import sarees from '../assets/Sri Lanka/E015.webp';
import dances from '../assets/Sri Lanka/DSC_2290-1038x576.jpg';
import stiltFishing from '../assets/Sri Lanka/S4.jpg';
import moonstones from '../assets/Sri Lanka/moonstone-3.jpg';
import cricket from '../assets/Sri Lanka/image_f8c21aee4f.jpg';
import herbs from '../assets/Sri Lanka/Ayurveda-making.jpg';
import masks from '../assets/Sri Lanka/Sri-lankan-Masks.jpg';

// === MOTION VARIANTS ===

const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (custom) => ({ opacity: 1, y: 0, transition: { delay: custom, duration: 0.8, ease: "easeOut" } }),
};
const scaleHover = {
    rest: { scale: 1, transition: { duration: 0.3, ease: "easeOut" } },
    hover: { scale: 1.05, transition: { duration: 0.3, ease: "easeOut" } },
};
const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5, ease: "easeOut" } },
};

const SriLanka = () => {
    const { t } = useTranslation('srilanka');
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (place) => setSelectedPlace(place);
    const closeModal = () => setSelectedPlace(null);
    const openImagePreview = (image) => setSelectedImage(image);
    const closeImagePreview = () => setSelectedImage(null);

    // === DATA ARRAYS — fully translated ===
    const places = [
        { name: t('sigiriya'), desc: t('sigiriyaDesc'), images: [place1, place17, place18, place19] },
        { name: t('templeOfTooth'), desc: t('templeOfToothDesc'), images: [place2, place20, place21, place22] },
        { name: t('ella'), desc: t('ellaDesc'), images: [place3, place23, place24, place25] },
        { name: t('yala'), desc: t('yalaDesc'), images: [place4, place26, place27, place28] },
        { name: t('galleFort'), desc: t('galleFortDesc'), images: [place5, place29, place30, place31] },
        { name: t('nuwaraEliya'), desc: t('nuwaraEliyaDesc'), images: [place6, place32, place33, place34] },
        { name: t('adamsPeak'), desc: t('adamsPeakDesc'), images: [place7, place35, place36, place37] },
        { name: t('hortonPlains'), desc: t('hortonPlainsDesc'), images: [place8, place38, place39, place40] },
        { name: t('bentota'), desc: t('bentotaDesc'), images: [place9, place41, place42, place43] },
        { name: t('jaffna'), desc: t('jaffnaDesc'), images: [place10, place44, place45, place46] },
        { name: t('anuradhapura'), desc: t('anuradhapuraDesc'), images: [place11, place47, place48, place49] },
        { name: t('polonnaruwa'), desc: t('polonnaruwaDesc'), images: [place12, place50, place51, place52] },
        { name: t('unawatuna'), desc: t('unawatunaDesc'), images: [place13, place53, place54, place55] },
        { name: t('colombo'), desc: t('colomboDesc'), images: [place14, place56, place57, place58] },
        { name: t('udawalawe'), desc: t('udawalaweDesc'), images: [place15, place59, place60, place61] },
        { name: t('dambulla'), desc: t('dambullaDesc'), images: [place16, place62, place63, place64] },
    ];

    const famousThings = [
        { title: t('ceylonTea'), desc: t('ceylonTeaDesc'), image: ceylonTea },
        { title: t('spices'), desc: t('spicesDesc'), image: spices },
        { title: t('gems'), desc: t('gemsDesc'), image: gems },
        { title: t('ayurveda'), desc: t('ayurvedaDesc'), image: ayurveda },
        { title: t('handicrafts'), desc: t('handicraftsDesc'), image: handicrafts },
        { title: t('elephants'), desc: t('elephantsDesc'), image: elephants },
        { title: t('food'), desc: t('foodDesc'), image: food },
        { title: t('festivals'), desc: t('festivalsDesc'), image: festivals },
        { title: t('coconut'), desc: t('coconutDesc'), image: coconut },
        { title: t('sarees'), desc: t('sareesDesc'), image: sarees },
        { title: t('dances'), desc: t('dancesDesc'), image: dances },
        { title: t('stiltFishing'), desc: t('stiltFishingDesc'), image: stiltFishing },
        { title: t('moonstones'), desc: t('moonstonesDesc'), image: moonstones },
        { title: t('cricket'), desc: t('cricketDesc'), image: cricket },
        { title: t('herbs'), desc: t('herbsDesc'), image: herbs },
        { title: t('masks'), desc: t('masksDesc'), image: masks },
    ];

    const intro = [t('intro1'), t('intro2'), t('intro3'), t('intro4'), t('intro5')];

    return (
        <div className="bg-[#001F3F] min-h-screen text-white font-sans">
            {/* HERO SECTION - Enhanced readability & subtle animation */}
            <motion.section
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1.2 }}
                className="relative h-[70vh] md:h-[85vh] lg:h-[100vh] flex items-center justify-center overflow-hidden"
            >
                <img
                    src={sriLankaHeroBg}
                    alt="Sri Lanka"
                    className="absolute inset-0 h-full w-full object-cover brightness-[0.65] scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30" />

                <div className="relative z-10 text-center px-6 max-w-5xl">
                    <motion.h1
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 1, ease: "easeOut" }}
                        className="inline-block text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold tracking-tight text-[#7FDBFF]"

                    >
                        {t('heroTitle')}
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.7, duration: 0.9 }}
                        className="mt-6 text-lg sm:text-xl md:text-2xl font-medium text-white/90 max-w-3xl mx-auto leading-relaxed"
                    >
                        {t('heroSubtitle')}
                    </motion.p>
                </div>

                {/* Bottom fade */}
                <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#001F3F] to-transparent" />
            </motion.section>

            {/* INTRO SECTION */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="py-16 md:py-24 container mx-auto px-5"
            >
                <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
                    <motion.div
                        whileHover={{ scale: 1.03 }}
                        transition={{ duration: 0.5 }}
                        className="w-full lg:w-1/2 rounded-3xl overflow-hidden shadow-2xl border border-white/10"
                    >
                        <img
                            src={introImage}
                            alt="Discover Sri Lanka"
                            className="w-full h-auto object-cover"
                            loading="lazy"
                        />
                    </motion.div>

                    <div className="w-full lg:w-1/2 space-y-6 text-white/90 text-lg leading-relaxed">
                        {intro.map((p, i) => (
                            <motion.p key={i} variants={fadeInUp} custom={i * 0.15}>
                                {p}
                            </motion.p>
                        ))}
                    </div>
                </div>
            </motion.section>

            {/* PLACES SECTION */}
            <section className="py-16 md:py-24">
                <div className="container mx-auto px-5">
                    <motion.h2
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                        className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-16 text-[#7FDBFF]"
                    >
                        {t('sectionPlaces')}
                    </motion.h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 md:gap-8">
                        {places.map((place, i) => (
                            <motion.div
                                key={i}
                                variants={scaleHover}
                                initial="rest"
                                whileHover="hover"
                                whileTap={{ scale: 0.98 }}
                                className="group relative rounded-2xl overflow-hidden cursor-pointer shadow-xl bg-gradient-to-b from-[#001F3F]/70 to-[#001F3F]/90 backdrop-blur-sm border border-white/10"
                                onClick={() => openModal(place)}
                            >
                                <div className="relative aspect-[4/3] overflow-hidden">
                                    <img
                                        src={place.images[0]}
                                        alt={place.name}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                        loading="lazy"
                                    />
                                    <motion.div
                                        variants={overlayVariants}
                                        className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex items-end justify-center pb-6"
                                    >
                                        <span className="text-white font-semibold text-lg px-4 text-center drop-shadow-lg">
                                            {place.name}
                                        </span>
                                    </motion.div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FAMOUS THINGS SECTION */}
            <section className="py-16 md:py-24 bg-[#001F3F]/40">
                <div className="container mx-auto px-5">
                    <motion.h2
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                        className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-16 text-[#7FDBFF]"
                    >
                        {t('sectionFamous')}
                    </motion.h2>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 md:gap-8">
                        {famousThings.map((item, i) => (
                            <motion.div
                                key={i}
                                variants={scaleHover}
                                initial="rest"
                                whileHover="hover"
                                className="group relative rounded-2xl overflow-hidden shadow-xl bg-gradient-to-b from-[#001F3F]/70 to-[#001F3F]/90 backdrop-blur-sm border border-white/10 aspect-[4/5] flex flex-col"
                            >
                                <div className="relative flex-1 overflow-hidden">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                        loading="lazy"
                                    />
                                    <motion.div
                                        variants={overlayVariants}
                                        className="absolute inset-0 bg-black/60 flex items-center justify-center p-6 opacity-0 group-hover:opacity-100"
                                    >
                                        <p className="text-white text-sm md:text-base text-center line-clamp-4">
                                            {item.desc}
                                        </p>
                                    </motion.div>
                                </div>
                                <div className="p-4 text-center">
                                    <h3 className="font-semibold text-lg text-white/95">{item.title}</h3>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* PLACE DETAIL MODAL */}
            <AnimatePresence>
                {selectedPlace && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-[#001F3F]/90 backdrop-blur-md flex items-center justify-center z-50 p-4 overflow-y-auto"
                    >
                        <motion.div
                            initial={{ scale: 0.88, opacity: 0, y: 50 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.88, opacity: 0, y: 50 }}
                            className="bg-gradient-to-b from-[#001F3F]/95 to-[#001F3F]/95 backdrop-blur-lg rounded-3xl p-6 md:p-10 max-w-5xl w-full max-h-[92vh] overflow-y-auto border border-white/10 shadow-2xl relative"
                        >
                            <button
                                onClick={closeModal}
                                className="absolute top-4 right-4 md:top-6 md:right-6 bg-white/10 hover:bg-white/20 text-white rounded-full p-3 transition-all"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>

                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8 text-[#7FDBFF]">
                                {selectedPlace.name}
                            </h2>

                            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-10">
                                {selectedPlace.images.map((img, idx) => (
                                    <motion.img
                                        key={idx}
                                        whileHover={{ scale: 1.06 }}
                                        src={img}
                                        alt={`${selectedPlace.name} ${idx + 1}`}
                                        className="w-full h-40 sm:h-56 md:h-64 object-cover rounded-2xl cursor-pointer shadow-md hover:shadow-xl transition-shadow border border-white/10"
                                        onClick={() => openImagePreview(img)}
                                        loading="lazy"
                                    />
                                ))}
                            </div>

                            <p className="text-white/90 text-base md:text-lg leading-relaxed font-light">
                                {selectedPlace.desc}
                            </p>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            {/* Image Preview Modal */}
            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-[#001F3F]/95 flex items-center justify-center z-[60] p-4"
                        onClick={closeImagePreview}
                    >
                        <motion.div
                            initial={{ scale: 0.9 }}
                            animate={{ scale: 1 }}
                            exit={{ scale: 0.9 }}
                            className="relative max-w-6xl w-full"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <img
                                src={selectedImage}
                                alt="Preview"
                                className="max-w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl mx-auto"
                            />
                            <button
                                onClick={closeImagePreview}
                                className="absolute -top-4 -right-4 bg-[#0074D9]/90 hover:bg-[#7FDBFF] text-white rounded-full p-3 transition"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            {/* Add this to your global CSS or tailwind config if needed */}
            <style jsx global>{`
        @keyframes gradientFlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}</style>
        </div>
    );
};

export default SriLanka;